export default {
  title: 'Are you sure you want to quit?',
  message: 'By leaving you will lose your information.',
  cancelButton: 'Cancel',
  confirmButton: 'Quit',
};
